

































































































import Vue from 'vue';
import i18n from 'vue-i18n';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';

Vue.use(i18n);

export default {
    name: 'SettingsMenu',
    components: { CoHeadline, CoCard, CoText },
    data() {
        return {
            space: this.$store.state.space,
        };
    },
};
